module.exports = __webpack_public_path__ + "static/img/picture8.2ac5fed3.png";